import { gql } from '@apollo/client'

export const SEND_AI_MESSAGE_MUTATION = gql`
  mutation SEND_AI_MESSAGE_MUTATION($input: AiMessageInput!) {
    sendAiMessage(input: $input) {
      conversationId
      response
      records {
        riskId
        templateId
        title
      }
      riskSuggestions {
        title
        fields {
          fieldId
          value
        }
      }
    }
  }
`

export const AI_CONVERSATION_DELETE_MUTATION = gql`
  mutation AI_CONVERSATION_DELETE_MUTATION($id: ID!) {
    deleteAiConversation(id: $id) {
      ok
    }
  }
`

export const SUMMARISE_RECORD_MUTATION = gql`
  mutation SUMMARISE_RECORD_MUTATION($input: AiRecordSummaryInput!) {
    summariseRecord(input: $input) {
      conversationId
      summary
    }
  }
`
